import { useState } from 'react';
import { useGetFreeTrialQuery } from '../api/freetrial/freeTrialApiSlice';

export function useFreeTrialSearch() {
    const [accountIdInput, setAccountIdInput] = useState('');
    const [searchedAccountId, setSearchedAccountId] = useState<string | null>(null);

    const queryResult = useGetFreeTrialQuery(searchedAccountId ?? '', {
        skip: !searchedAccountId,
    });

    const search = () => {
        if (!accountIdInput) {
            return;
        }
        setSearchedAccountId(accountIdInput);
    };

    return {
        accountIdInput,
        setAccountIdInput,
        searchedAccountId,
        search,
        ...queryResult,
    };
}
